import { localToday } from './time.js';
/**
 * Smart task prioritization weighting (shared by the web DayPlanner, the mobile
 * up-next queue, and the photo wizard). Pure — no Firestore I/O.
 *
 * Money-earning tasks first, then by priority weight with an overdue boost.
 */
export const PRIORITY_WEIGHT = { critical: 100, high: 70, medium: 40, low: 10 };

export function taskPriorityWeight(task, today) {
  const t = today || localToday();
  const base = PRIORITY_WEIGHT[task.priority] ?? 40;
  const overdue = task.scheduledDate && task.scheduledDate < t ? 30 : 0;
  return base + overdue;
}

export function smartSortTasks(tasks, { today } = {}) {
  const t = today || localToday();
  return [...tasks].sort((a, b) => {
    const aMoney = (a.moneyEarned || 0) + (a.actualValue || 0);
    const bMoney = (b.moneyEarned || 0) + (b.actualValue || 0);
    if (aMoney > 0 && bMoney === 0) return -1;
    if (bMoney > 0 && aMoney === 0) return 1;
    return taskPriorityWeight(b, t) - taskPriorityWeight(a, t);
  });
}
